module.exports = __webpack_public_path__ + "img/vendorGuide.d73f578e.jpg";